var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSynaFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 24,
    viewBox: "0 0 68 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kgv2z7jmha)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.354 6.89-4.496 12.065c-1.188 3.18-2.999 4.935-6.05 4.935H14.62c-.421 0-.768-.22-.768-1.024v-.42c0-.823.365-1.042.768-1.042h.549c1.48 0 2.559-.878 3.18-2.576l.163-.44-4.588-11.495c-.201-.492.057-.932 1.21-.932h1.023c1.151 0 1.535.44 1.7.932l2.622 7.823 2.42-7.823c.147-.492.549-.932 1.7-.932h.549c1.17-.002 1.39.438 1.206.93zM26.941 18.004V10.78c0-3.382 2.066-5.1 6.069-5.1s6.075 1.74 6.075 5.1V18c0 .492-.311.932-1.412.932h-.821c-1.133 0-1.426-.44-1.426-.932v-7.107c0-1.736-.696-2.503-2.42-2.503-1.755 0-2.448.767-2.448 2.503v7.111c0 .492-.275.932-1.412.932h-.823c-1.107 0-1.382-.44-1.382-.932zM52.397 10.235v4.806c0 2.963-1.846 4.169-5.885 4.169-4.113 0-5.996-1.317-5.996-3.877v-.272c0-2.523 1.754-3.71 5.445-3.894l3.007-.164v-.367c0-1.47-.807-2.228-2.622-2.192a11.564 11.564 0 0 0-3.398.64l-.66.255c-.548.146-.822.019-.986-.639l-.202-.86c-.145-.584-.018-.858.44-1.042l.968-.365a11.867 11.867 0 0 1 4.332-.768c3.943.018 5.557 1.627 5.557 4.57zm-3.429 4.806v-2.017l-2.174.109c-1.847.109-2.725.64-2.725 1.864v.256c0 1.244.605 1.847 2.45 1.847 1.755.008 2.45-.633 2.45-2.06z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.212 18.388.801 17.93c-.549-.202-.712-.547-.53-1.242l.255-.878c.22-.768.53-.877 1.134-.712l1.079.347c1.393.462 2.847.715 4.314.748 2.34 0 3.49-.806 3.49-2.283 0-1.299-.913-1.682-2.851-2.285l-2.42-.695C2.36 10.07.458 8.774.458 5.756c0-3.38 2.448-5.794 7-5.756a14.47 14.47 0 0 1 4.66.767l1.243.44c.53.201.696.53.53 1.187l-.255.924c-.218.768-.493.877-1.077.694l-.932-.31a12.536 12.536 0 0 0-3.877-.694c-2.339 0-3.325.877-3.325 2.303s.968 1.815 2.777 2.357l2.42.712c3.227.916 4.917 2.195 4.917 5.1 0 3.492-2.505 5.74-7.26 5.74a15.36 15.36 0 0 1-5.067-.832z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2 5.688H54v13.2h13.2v-13.2z",
    fill: "#FFC300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kgv2z7jmha"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h67.16v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynaFooterLogo);
export default __webpack_public_path__ + "static/media/syna-footer-logo.19a3f8833807b21ace9db75065c80026.svg";
export { ForwardRef as ReactComponent };